import { mallApi, mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const coupon = {
  receiveCoupon: data => mallApi.post(apiPath.receiveCoupon, data),
  getcouponpage: data => mallApi.post(apiPath.getcouponpage, data),
  getCouponCenterBanner: data =>
    mallApi.post(apiPath.getCouponCenterBanner, data),
  getCouponCenterList: data => mallApi.post(apiPath.getCouponCenterList, data),
  receiveCouponInCouponCenter: data =>
    mallApi.post(apiPath.receiveCouponInCouponCenter, data),
  centerTop: data => mallEntranceApi.post(apiPath.centerTop, data),
  centerTabs: data => mallEntranceApi.post(apiPath.centerTabs, data),
  centerGetByTab: data => mallEntranceApi.post(apiPath.centerGetByTab, data),
  myCouponList: data => mallEntranceApi.post(apiPath.myCouponList, data),
  transferCoupon: data => mallEntranceApi.post(apiPath.transferCoupon, data),
  listTransferableUnit: data =>
    mallEntranceApi.post(apiPath.listTransferableUnit, data)
}
